import React from 'react';

import { ExportArrivalNotice as ExportArrivalNoticeImpl } from '@components/utilities/BookingInquiry/ExportArrivalNotice';

export const ExportArrivalNotice: React.FC = () => {
  return <ExportArrivalNoticeImpl />;
};
